import React from 'react'
import { NavLink } from 'react-router-dom'
import { Heart, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#0c4a6e"/>
        </svg>
      </div>
      <div className="footer__body">
        <div className="container">
          <div className="footer__grid">
            {/* Brand */}
            <div className="footer__brand">
              <div className="footer__logo">
                <div className="footer__logo-icon">MSS</div>
                <div>
                  <div className="footer__logo-name">Malyabanta</div>
                  <div className="footer__logo-sub">Swechhasevi Samiti</div>
                </div>
              </div>
              <p className="footer__tagline">
                Lighting the path of education for underprivileged tribal children. Every child deserves a future.
              </p>
              <div className="footer__social">
                <a href="#" aria-label="Facebook" className="footer__social-link"><Facebook size={18}/></a>
                <a href="#" aria-label="Twitter" className="footer__social-link"><Twitter size={18}/></a>
                <a href="#" aria-label="Instagram" className="footer__social-link"><Instagram size={18}/></a>
                <a href="#" aria-label="YouTube" className="footer__social-link"><Youtube size={18}/></a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer__col">
              <h4 className="footer__col-title">Quick Links</h4>
              <ul className="footer__links">
                <li><NavLink to="/">Home</NavLink></li>
                <li><NavLink to="/about">About Us</NavLink></li>
                <li><NavLink to="/our-work">Our Work</NavLink></li>
                <li><NavLink to="/raise-fund">Raise Fund</NavLink></li>
                <li><NavLink to="/donate">Donate</NavLink></li>
                <li><NavLink to="/contact">Contact Us</NavLink></li>
              </ul>
            </div>

            {/* Programs */}
            <div className="footer__col">
              <h4 className="footer__col-title">Our Programs</h4>
              <ul className="footer__links">
                <li><a href="#education">Free Education</a></li>
                <li><a href="#hostel">Hostel Facility</a></li>
                <li><a href="#skills">Skill Development</a></li>
                <li><a href="#tuition">Free Tuition</a></li>
                <li><a href="#nutrition">Child Nutrition</a></li>
                <li><a href="#vocational">Vocational Training</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer__col">
              <h4 className="footer__col-title">Contact Us</h4>
              <ul className="footer__contact">
                <li>
                  <MapPin size={16}/>
                  <span>MSS, Malyabanta, Odisha, India</span>
                </li>
                <li>
                  <Mail size={16}/>
                  <a href="mailto:malyabantaswechhasevisamitibml@gmail.com">malyabantaswechhasevisamitibml@gmail.com</a>
                </li>
                <li>
                  <Phone size={16}/>
                  <a href="tel:+919876543210">+91 98765 43210</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer__bottom">
            <p>© {new Date().getFullYear()} Malyabanta Swechhasevi Samiti. All rights reserved.</p>
            <p className="footer__love">Made with <Heart size={13} className="footer__heart"/> for tribal children</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
